import MapComponent from '../Component/map/map'
import Layout from '../Component/layout/main-layout'
import { useTranslation } from 'react-i18next'
import layoutBgImg from '../Images/layout/map.jpg'
import GlobalLayout from '../Component/layout/global-layout'

const Map = () => {
    const { t } = useTranslation()
    return (
        <GlobalLayout
            title={`${t('contacts')} - ${t('supreme_court')} ${t('turkmenistan')}`}
            keywords="Türkmenistanyň kartasy, Kazyýet edaralary, Kazyýet edaralarynyň kartasy,
                      Turkmenistanyn kartasy, Kazyyet edaralary, Kazyyet edaralarynyn kartasy, Karta"
        >
            <div className='mb-20'>
                <Layout
                    title={t('contacts')}
                    layoutBgImg={layoutBgImg}
                />
                <div className='mt-8 media'>
                    <MapComponent />
                </div>
            </div>
        </GlobalLayout>
    )
}

export default Map